import { render, staticRenderFns } from "./AdminSchedulesBatchModalChangeWeekdays.vue?vue&type=template&id=0f0542a4&scoped=true"
import script from "./AdminSchedulesBatchModalChangeWeekdays.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesBatchModalChangeWeekdays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0542a4",
  null
  
)

export default component.exports